import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import logo from '../../../../public/assets/logo.svg';
import { Box, Button, Typography } from '@mui/material';
import { centered } from '../freelancer/account/style';
import { QInput } from '../../components/common/inputs/QInput';
import { PrimaryButon } from '../../components/common/button/PrimaryButon';
import { colCenter } from '../../style/style';
import { useNavigate } from 'react-router-dom';
import { translate } from '@application/common/helpers/translate';
import { Controller, useForm } from 'react-hook-form';
import { forgotPasswordAsync } from '@application/features/auth/authThunks';
import { useAppDispatch } from '@application/store/useStore';
export const ForgotPassword = () => {
    const [step, setStep] = useState(1);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { control, handleSubmit, formState: { errors } } = useForm();
    const onSubmit = (data) => {
        dispatch(forgotPasswordAsync(data))
            .unwrap()
            .then((res) => {
            if (res) {
                setStep(2);
            }
        })
            .catch((error) => { });
    };
    return (_jsx("form", { onSubmit: handleSubmit(onSubmit), children: _jsx(Box, { sx: { width: '100%', ...centered, height: '100svh', px: 0.5 }, children: step === 1 ? (_jsxs(Box, { width: '386px', sx: { ...colCenter, flexDirection: 'column' }, children: [_jsx("img", { src: logo, alt: '' }), _jsx(Typography, { variant: 'h3', color: '#000000', mt: 3, children: "Forgot your password?" }), _jsx(Typography, { textAlign: 'center', variant: 'subtitle1', color: '#555555', children: "Please enter the email you use to sign in to QPortal" }), _jsx(Controller, { name: 'email', control: control, defaultValue: '', rules: {
                            required: {
                                value: true,
                                message: translate('validations.fieldIsRequired')
                            },
                            pattern: {
                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                message: translate('validations.invalidEmailAddress')
                            }
                        }, render: ({ field }) => (_jsx(QInput, { ...field, mt: 2.5, placeholder: 'Your email', errormsg: errors.email ? errors.email.message : '' })) }), _jsx(PrimaryButon, { mt: 24, type: 'submit', mb: 1, children: "Request password reset" }), _jsx(Button, { variant: 'text', size: 'large', onClick: () => navigate('/login'), fullWidth: true, sx: { fontWeight: 550 }, children: "Back to sign in" })] })) : (_jsxs(Box, { sx: { ...centered, flexDirection: 'column' }, children: [_jsx("img", { src: logo, alt: '' }), _jsx(Typography, { variant: 'h3', mt: 5, textAlign: 'center', color: 'initial', children: "You've received an email with instructions" }), _jsx(Typography, { variant: 'h3', textAlign: 'center', color: 'initial', children: "to reset your password." }), _jsx(Box, { width: 386, children: _jsx(PrimaryButon, { onClick: () => navigate('/login'), mt: 24, children: "Back to sign in" }) })] })) }) }));
};
